import React from 'react';
import { css, CSSProperties } from '@compiled/react';
import { Heading, HeadingProps, useDeviceSize } from '@atlassian/learning-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

import { getOptions } from 'src/pages/LessonPage/children/utils/getOptions';
import { getInspectModeData } from 'src/utils/contentful';
import { ContentfulLessonSectionContainer } from 'src/graphql/queries/GetSmLesson';

interface LessonSectionProps {
  section: ContentfulLessonSectionContainer;
  titleLevel?: HeadingProps['level'];
  titleContainerStyle?: CSSProperties;
  withoutMainWidthStyles?: boolean;
}

export const LessonSection: React.FC<LessonSectionProps> = ({
  section,
  titleLevel = 2,
  titleContainerStyle,
  withoutMainWidthStyles = false,
}) => {
  const deviceWidth = useDeviceSize();
  const inspectorProps = useContentfulInspectorMode();

  return (
    <div
      key={section.sys.id}
      css={defaultContainerStyle}
      style={{ backgroundColor: section.backgroundColor ?? '#FFFFFF' }}
    >
      <section id={section.sys.id} data-testid={section.sys.id} css={lessonSectionStyles}>
        {section.title && (
          <div css={defaultTitleContainerStyle} style={titleContainerStyle}>
            <Heading
              level={titleLevel}
              id={section.id.replace(' ', '-')}
              inspectMode={getInspectModeData(section, ['title'])}
            >
              {section.title}
            </Heading>
          </div>
        )}
        <div
          data-testid="lesson-section-children"
          {...inspectorProps({ entryId: section.sys.id, fieldId: 'children' })}
        >
          {section?.children?.json &&
            documentToReactComponents(
              section?.children?.json,
              getOptions(section?.children, deviceWidth, undefined, withoutMainWidthStyles),
            )}
        </div>
      </section>
    </div>
  );
};

const lessonSectionStyles = css({
  maxWidth: '1020px',
  boxSizing: 'content-box',
  margin: '0 auto',

  a: {
    fontSize: '20px',
    fontFamily: 'Inter, sans-serif',
  },
});

const defaultContainerStyle = css({ padding: '80px 16px' });

const defaultTitleContainerStyle = css({ margin: '20px auto', maxWidth: '720px' });
